import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  const invalidateQuery = useCallback((queryKey: unknown) => {
    const processedKey = typeof queryKey === 'string' ? [queryKey] : queryKey;
    queryClient.invalidateQueries({ queryKey: processedKey as readonly unknown[] });
  }, [queryClient]);

  return invalidateQuery;
};
